import { useMemo } from 'react'

export const useDisabledHover = shouldCreateCollection => {
    const warningHover = useMemo(
        () =>
            (shouldCreateCollection && {
                'data-tooltip-id': 'default-tip',
                'data-tooltip-content':
                    'Not available with your user account type. Contact Parse admins for additional information',
            }) ||
            {},
        [shouldCreateCollection],
    )
    
    /* useEffect(() => {
        Tooltip.rebuild()
    }, [shouldCreateCollection, shouldHover]) */
    
    return warningHover
}
